<template>
  <dc-layout-main>
    <dc-layout-content>
      <cos-table serial :columns="columns" @fetch="fetch" v-model:search="queryForm" ref="tableRef" tableId="DcCosBlackList">
        <template #search>
          <a-form :model="queryForm">
            <dc-form-item name="customerName" label="客户名称">
              <a-input v-model:value="queryForm.customerName" allowClear placeholder="请输入" />
            </dc-form-item>
            <dc-form-item name="arkCode" label="客户代码">
              <a-input v-model:value="queryForm.arkCode" allowClear placeholder="请输入" />
            </dc-form-item>
          </a-form>
        </template>
        <template #bodyCell="{ column, record }">
          <template v-if="column.dataIndex === 'enableFlag'"> 拉黑 </template>
          <template v-if="column.dataIndex === 'action'">
            <more-button>
              <a-button type="link" @click="addEdit(record)" v-permission="'fbu_blacklist_edit_btn'">编辑</a-button>

              <a-button type="link" @click="deleteRow(record)" v-permission="'fbu_blacklist_delete_btn'">删除</a-button>
            </more-button>
          </template>
        </template>
        <template #button>
          <a-button type="primary" @click="addEdit()" v-permission="'fbu_blacklist_add_btn'">新增</a-button>
        </template>
      </cos-table>
      <editModal ref="editModalRef" @success="success" />
    </dc-layout-content>
  </dc-layout-main>
</template>
<script lang="ts">
import editModal from './components/editModal.vue'
import Modal from '@/hooks/modalType'
import { reactive, ref, computed } from 'vue'
import { blackFindByPage, deleteData } from '@/api/gucangSales/blackList'
import { listByParamCodes } from '@/api/common'

import { DcMessage } from '@dc-platform/dc-components'
import { BlackFindByPageParams, BlackFindByPageBackData } from '@/typings/api/gucangSale'
export default { name: 'DcCosFbuBlacklist' }
</script>
<script setup lang="ts">
const editModalRef = ref<{ toggle:(row?: BlackFindByPageBackData) => void }>()

const tableRef = ref()
const queryForm = reactive({
  customerName: '',
  arkCode: ''
})
const paramCodeData = ref([])
const getBlackReason = async () => {
  // 对列表数据进行修改。通过拉黑原因id查原因
  try {
    const res = await listByParamCodes({
      appId: 'cos_fbu',
      paramCodes: ['fbu_black_reason']
    })
    paramCodeData.value = res.data.fbu_black_reason
  } catch (error) {
    console.log('getBlackReason error: ', error)
  }
}
// 获取列表
const fetch = async (params: BlackFindByPageParams, callBack: (res: any) => void) => {
  try {
    const res = await blackFindByPage({ ...params })
    await getBlackReason()
    callBack(res)
  } catch (error) {
    console.log('fetcherror: ', error)
  }
}

const success = (type?: 'search' | 'fetch') => {
  if (type === 'search') {
    tableRef.value.search()
  } else {
    tableRef.value.fetch()
  }
}
const columns = computed(() => [
  { title: '客户名称', dataIndex: 'customerName' },
  { title: '拉黑原因', dataIndex: 'blacklistReason', dicData: paramCodeData.value },

  { title: '备注', dataIndex: 'blacklistRemark' },
  { title: '状态', dataIndex: 'enableFlag' },
  {
    title: '操作',
    dataIndex: 'action',
    fixed: 'right'
  }
])
const addEdit = (_row?: BlackFindByPageBackData) => {
  editModalRef.value?.toggle(_row)
}
const deleteRow = (row: BlackFindByPageBackData) => {
  Modal.delete({
    name: row.customerName,
    onOk() {
      deleteData(row.id).then(() => {
        DcMessage.success('删除成功')
        tableRef.value?.delFetch()
        success()
      })
    }
  })
}
</script>

<style scoped></style>
